import { render, staticRenderFns } from "./PantryItemDetailsPage.vue?vue&type=template&id=0b5bbd8f&"
import script from "./PantryItemDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./PantryItemDetailsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports